import React from 'react';
import { Calendar } from 'lucide-react';

interface MonthOption {
  year: number;
  month: number;
  label: string;
  count: number;
}

interface StickyMonthHeaderProps {
  year: number;
  month: number;
  eventCount: number;
  allMonths: MonthOption[];
  onJumpTo: (year: number, month: number) => void;
}

const MONTH_NAMES = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];

export const StickyMonthHeader: React.FC<StickyMonthHeaderProps> = ({
  year,
  month,
  eventCount,
  allMonths,
  onJumpTo
}) => {
  const monthLabel = MONTH_NAMES[month];

  return (
    <div className="sticky top-0 z-20 bg-white/95 dark:bg-medical-900/95 backdrop-blur-sm border-b border-medical-200 dark:border-medical-700 shadow-sm">
      <div className="px-4 py-2.5 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <div className="w-7 h-7 rounded-md bg-primary-50 dark:bg-primary-900/30 flex items-center justify-center">
            <Calendar className="h-4 w-4 text-primary-600 dark:text-primary-500" />
          </div>
          <div>
            <h3 className="text-sm font-semibold text-medical-900 dark:text-medical-100">
              {monthLabel} {year}
            </h3>
            <p className="text-xs text-medical-500 dark:text-medical-400">
              {eventCount} {eventCount === 1 ? 'event' : 'events'}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
